import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  children: React.ReactNode;
  tooltipKey?: string;
  hasErrors?: boolean;
  className?: string;
  containerWidth?: 'small' | 'medium';
};

export default function FormGroupWithTooltip({
  children,
  tooltipKey,
  hasErrors,
  className = 'form-group',
  containerWidth = 'medium',
}: Props) {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const colWidthClass = containerWidth === 'small' ? 'col-sm-2' : 'col-sm-3';

  const handleFocus = () => setIsFocused(true);

  const handleBlur = (e: React.FocusEvent) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      setIsFocused(false);
    }
  };

  return (
    <div className={className} onFocus={handleFocus} onBlur={handleBlur}>
      {children}
      {isFocused && !hasErrors && tooltipKey && (
        <div className={`${colWidthClass} popUp-date-container-tooltip`}>
          {t(tooltipKey)}
        </div>
      )}
    </div>
  );
}
